<template>
    <div class="wrap wrap--sub">
        <!-- 헤더 -->
        <main-header />

        <!-- 메인 -->
        <main class="main" role="main">
            <div class="collection-index-container">
                <div class="page-head">
                    <div class="page-head__inner">
                        <h1 class="page-head__title">COLLECTION</h1>
                        <ul class="breadcrumb">
                            <li class="breadcrumb__list">Checkout the DID sample books</li>
                            <!-- <li class="breadcrumb__list">컬렉션</li>
                            <li class="breadcrumb__list">국내</li>
                            <li class="breadcrumb__list">디앤디 컬렉션 인덱스</li> -->
                        </ul>
                    </div>
                </div>

                <div class="container">
                    <div v-for="({ name, children: collections }, index) in categories" :key="`categories-${index}`">
                        <div class="collection-list-subtitle-wrap">
                            <div class="box-icon orange"></div>
                            <h3 class="collection-list-subtitle-header">{{ name }}</h3>
                            <div class="line"></div>
                        </div>
                        <div class="container2">
                            <collection-list :collections="collections"></collection-list>
                        </div>
                    </div>

                    <!-- <div class="collection-text">
                        <p>“ 논현동 디아이디 패밀리샵에는 3권 외에, <strong class="color-point">세계적으로 인정받는 2,000종 이상의 수출벽지가 비치</strong>되어 있고, <strong class="color-point">실제 집처럼 크게 도배</strong>되어 있습니다. ”</p>
                        <small>(현장에서 바로 구매 가능)</small>
                    </div> -->
                </div>
            </div>
        </main>

        <!-- 푸터 -->
        <main-footer />
    </div>
</template>

<script>
import MainHeader from "@/components/client/inc/main-header.vue";
import MainFooter from "@/components/client/inc/main-footer.vue";

import CollectionList from "@/components/client/collection/collection-list.vue";

export default {
    components: {
        MainHeader,
        MainFooter,
        CollectionList,
    },
    data() {
        return {
            categories: [],
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            try {
                var {
                    data: { categories },
                } = await this.$http.get("/api/v1/shop/categories", { params: { depth: 1 } });

                this.categories = categories;
            } catch (error) {
                console.error(error);
                if (error.response) alert(error.response.data.message);
            }
        },
    },
};
</script>
